import styled from "styled-components";

export const UnlimitedDemoTradesStatusStyled = styled.div`
    padding: 8px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--color-label-secondary);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    border-radius: 16px;
    background: radial-gradient(65.22% 65.22% at 50% 15.22%, rgba(243, 241, 122, 0.08) 0%, rgba(243, 241, 122, 0.00) 100%), #262840;
    
    .unlimited-demo-trade-status-circle {
        border-radius: 50%;
        background: var(--gradients-yellow-pink);
        display: flex;
        justify-content: center;
        align-items: center;
        width: 32px;
        height: 32px;
        flex-shrink: 0;
        color: var(--color-background-neutral-primary-black);
    }
`;
